import "./profile_pic.scss";

interface Props {
  path?: string;
  size?: number;
}

const ProfilePicture = ({ path, size }: Props) => {
  return (
    <div
      className="profile-pic"
      style={{
        backgroundImage: `url(${path})`,
        minWidth: size,
        minHeight: size,
      }}
    />
  );
};

export default ProfilePicture;
